import React, { Component } from 'react';
import { 
    Box,
    TextField, 
} from '@mui/material';
import { Button } from 'react-bootstrap';

export class SearchBarV2 extends Component {
    state = {  }
    render() {
        return (
            <Box style={{ display:"flex", justifyContent:"space-between", alignItems: "center"}}>
                <Box p={1} style={{width:"100%"}} >
                    <TextField
                        style={{width:"100%"}}
                        onChange={this.props.handleChange}
                        variant="outlined"  
                        name={this.props.name || "search"} 
                        id={this.props.name || "search"} 
                        value={this.props.searchValue} 
                        label={this.props.label} 
                        placeholder="Rechercher"
                    />
                </Box>
                <Box p={1} style={{textAlign: "right"}}>
                    {this.props.children}
                </Box>
            </Box>                
        );
    }
}
class SearchBar extends Component {
    state = {  }
    render() {
        return (
            <Box p={1} style={{width:"100%"}}>
                <TextField
                    style={{width:"100%"}}
                    onChange={this.props.handleChange}
                    // margin="normal"
                    variant="outlined"  
                    name={this.props.name || "search"} 
                    id={this.props.name || "search"} 
                    value={this.props.searchValue} 
                    label={this.props.label} 
                    placeholder="Rechercher"
                />
            </Box>
        );
    }
}

export default SearchBar;